import { render, staticRenderFns } from "./StaticPages.vue?vue&type=template&id=1be9ae2c&scoped=true"
import script from "./StaticPages.vue?vue&type=script&lang=js"
export * from "./StaticPages.vue?vue&type=script&lang=js"
import style0 from "./StaticPages.vue?vue&type=style&index=0&id=1be9ae2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be9ae2c",
  null
  
)

export default component.exports